const PERCENT_FILTER_ATTRIBUTES = ['percent_thc', 'percent_cbd'];
const RANGE_FILTERS_ATTRIBUTES = [
  'bucket_price',
  'review_count',
  ...PERCENT_FILTER_ATTRIBUTES,
];

export { PERCENT_FILTER_ATTRIBUTES, RANGE_FILTERS_ATTRIBUTES };
